import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-xl font-bold text-background-50">
              挣扎吧亚当君
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              在命运的洪流中，每一个选择都值得被尊重。探索亚当君的挣扎历程，感受互动叙事的无限可能。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                首页
              </Link>
              <Link to="/category/all" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                全部文章
              </Link>
              <Link to="/category/gonglue" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                攻略指南
              </Link>
              <Link to="/category/juese" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                角色解析
              </Link>
              <Link to="/category/juqing" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                剧情讨论
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                品牌介绍
              </Link>
              <a href="/about#testimonials" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                玩家口碑
              </a>
              <a href="/about#contact" className="text-sm text-background-300 hover:text-background-100 transition-colors">
                联系我们
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-background-300 mb-3">
              订阅最新资讯，第一时间获取游戏更新和独家内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-all duration-300" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-all duration-300" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-all duration-300" aria-label="微信公众号">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-all duration-300" aria-label="小红书">
                <i className="ri-reddit-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 挣扎吧亚当君制作组. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}